<template>
  <div class="box" ref="place_ref"></div>
</template>

<script>
export default {
  props: {
    dynamicTags: Array
  },
  data() {
    return {
      mychart: null,
      tableData: [
      ],
       emotionList: {
        1: "正面情绪",
        2: "负面情绪",
        3: "不确定",
      },
    };
  },
  watch: {
    dynamicTags(){
       this.tableData = [];
       this.tableData = this.dynamicTags;
       this.updateData();
    }
    
  },
  mounted() {
    console.log("fafas",this.dynamicTags);
    this.initchart();
    this.getData();
     
  },
  methods: {
    initchart() {
      this.mychart = this.echarts.init(this.$refs.place_ref)
    },
    updateData() {
      const xData = this.tableData.map((item) => item.value);
      const yData = this.tableData[0].key.map((item) => this.emotionList[item]);
      const name = this.tableData.map((item) => item.name);
      console.log(xData, yData,name);
      var color = [
        "#2ca1ff",
        "#febe13",
        "#85f67a",
        "#7b2cff",
        "#fd5151",
        "#f071ff",
        "#0adbfa",
        "#65e5dd",
        "#5ce0e2",
      ];
       const series = [];
        for (var i = 0; i < xData.length; i++) {
        series.push({
           type: "radar",
            data: [
              {
                value: xData[i],
                name: name[i],
              }
            ],
            itemStyle: {
              color: "#F9713C",
              normal: {
                borderWidth: 5,
                shadowBlur: 20,
                borderRadius: 30,
                borderColor: color[i],
                shadowColor: color[i],
              },
            },
            areaStyle: {
              opacity: 0.3,
            },
            lineStyle: {
              width: 4,
              color: color[i], //线颜色
              shadowColor: color[i], //点颜色
              shadowBlur: 20,
            },
        });
      }
      const indicator = []
      for (var i = 0; i < yData.length; i++) {
        indicator.push({
           name: yData[i], max:30 
        });
      }
      
      
      const option = {
        legend: {
          bottom: 10,
          // selectedMode: "single",
          // orient: "horizontal", //横向
          data: name,
          // textStyle: { color: "white" },
        },
        radar: {
          indicator:indicator,
        },
        series: series,
      };
      this.mychart.setOption(option);
      console.log(option);
    },
    // 获取事件
    getData() {
      this.updateData();
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 400px;
  margin: 0 auto;
  &>div{
     height: 100%;
  }
  &>canvas{
    height: 100%;
  }
}
</style>